/** 与 localStorage 同步的令牌读取，供 axios 拦截器使用（避免与 store 循环依赖） */
const TOKEN_KEY = 'admin_token'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}
